import React, { CSSProperties } from 'react';

import {
  type SupportedPaymentCurrency,
  formatCurrencyWithSymbolOnly,
  currencyToCode,
} from 'domains-billing-currency';
import { M } from 'design-system-web';

type Props = {
  amount: number;
  amountStyle?: CSSProperties;
  currencyCode: SupportedPaymentCurrency;
  isTotal?: boolean;
};

export function DisplayCurrency({
  amount,
  amountStyle,
  currencyCode,
  isTotal,
}: Props) {
  const formattedAmount = formatCurrencyWithSymbolOnly(currencyCode, amount);
  const currencyCodeString = currencyToCode(currencyCode);

  if (isTotal) {
    return (
      <div>
        {`${currencyCodeString} `}
        <M bold style={amountStyle}>
          {formattedAmount}
        </M>
      </div>
    );
  }

  return <M>{formattedAmount}</M>;
}
